module.exports = __webpack_public_path__ + "img/Porto Apartment - 47 of 85.8edf57a0.jpeg";